export default () => ({
  template: require('./retention_table.html'),
  scope: {
    data: '=data',
    get_data_method: '=getDataMethod',
  },
  controller: [
    '$scope',
    '$rootScope',
    'chartFilters',
    function RetentionTableCtrl($scope, $rootScope, chartFilters) {
      $scope.ranges = {};
      $scope.gradient_colors = [
        '#ecf8ff',
        '#E6F5FF',
        '#DBF0FF',
        '#D1ECFF',
        '#C7E8FF',
        '#BDE4FF',
        '#B3E0FF',
        '#A8DCFF',
        '#9ED8FF',
        '#94D4FF',
        '#8AD0FF',
        '#80CCFF',
        '#78c4ff'
      ];

      $scope.apply_color = function(value, key) {
        if (value !== -1) {
          const position =
            (value - $scope.ranges[key]['min']) /
            ($scope.ranges[key]['max'] - $scope.ranges[key]['min']);
          return $scope.gradient_colors[
            Math.floor(position * ($scope.gradient_colors.length - 1))
          ];
        }
      };
      $scope.apply = function(value) {
        if (value === -1) {
          return '-';
        } else {
          return value;
        }
      };
      $scope.calculate_ranges = function() {
        const data_keys = Object.keys($scope.data[0]);
        for (let key_i = 0; key_i < data_keys.length; key_i++) {
          const values_list = [];
          for (let i = 0; i < $scope.data.length; i++) {
            values_list.push($scope.data[i][data_keys[key_i]]);
          }
          $scope.ranges[data_keys[key_i]] = {
            min: Math.min.apply(Math, values_list),
            max: Math.max.apply(Math, values_list)
          };
        }
      };
      $scope.update_retention_table = function(model) {
        $scope.get_data_method(model).then(function(resp) {
          $scope.data = resp;
          $scope.calculate_ranges();
        });
      };
      chartFilters.onChangeChartParams(
        'update_retention_table',
        $scope.update_retention_table
      );
      $scope.update_retention_table(chartFilters.get_chart_filters());
    }
  ],
});
